import styled from "styled-components";
import { JACKPOT_WIDGET, RED_TIGER_JACKPOT } from "../../constants";
import { ListTitleTextDefaultBox } from "./list-title-text.default.box";

export const ListTitleTextSICisBox = styled(ListTitleTextDefaultBox)`
    ${({theme}) => theme.font.presets.medium};
    
    letter-spacing: 0.56px;
    font-size: 14px;
    background-image: linear-gradient(to right, ${props => props.theme.colors.backgroundContrast} 0%, ${props => props.theme.colors.backgroundContrast} 70%, ${props => props.theme.colors.background}00 100%);
    background-color: ${props => props.theme.colors.backgroundContrast};

    border-left: none;
    
    .${JACKPOT_WIDGET} & {
        border-left: none;
    }

    .${RED_TIGER_JACKPOT} & {
        border-left: none;
    }
`;
